import { DELAY_CALLOUT_WITH_ANIMATION_TIME } from 'consts/consts';
import { POPUP_OPEN_TYPE, SCREEN_TYPE } from 'consts/enum';
import { addClass, getFontSetting, hasClass, isMobileOrTablet, removeClass, setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { LauncherIcon } from 'launcherIcon/launcherIcon.module';
import { Popup } from 'popup/popup.module';
import { setLocalizedString } from '../../index';
import { AppModel } from './app.model';
import { AppTemplate } from './app.template';

export const AppComponent = {
	async init() {
		this.appElement = document.body;
		await this.initData();
		await this.initWrapper();
		await this.initComponents();

		await this.render();
		await setLocalizedString();
		this.initEventHandlers();
	},

	setupPopup() {
		let delay = ENGT_CHAT.get('config.autoPopupDelay');
		const popupType = ENGT_CHAT.get('config.autoPopupType');
		const overridePopup = ENGT_CHAT.get('config.override_pop_up');
		const launchScreenEnabled = ENGT_CHAT.get('config.isLaunchScreenEnabled');

		const isPopupHidden = () => hasClass(document.getElementById('engt-popup'), 'engt-popup-hidden');

		const showClosedCallout = () => {
			addClass(document.getElementById('engtClosedCallout'), 'engt-closed-callout');
			removeClass(document.getElementById('engtClosedCallout'), 'engt-closed-callout-hidden');
		};

		const onClosedCallout = () => {
			if (isPopupHidden()) {
				if (ENGT_CHAT.get('config.trigger_configurations')?.length) {
					const triggerWrapper = document.getElementById('engt-triggers-wrapper');
					const isTriggersWrapperShown = triggerWrapper?.style?.display === 'block';
					if (isTriggersWrapperShown) {
						addClass(triggerWrapper, 'engt-triggers-callout-animation-up');
						setTimeout(() => {
							showClosedCallout();
						}, 1000);
					} else {
						showClosedCallout();
					}
				} else {
					showClosedCallout();
				}
			}
		};

		const onMinizedCallout = () => {
			if (isPopupHidden()) {
				ENGT_CHAT.get('onLauncherClick')();
				addClass(document.getElementById('engt-popup'), 'engt-popup-minimized');
			}
		};

		launchScreenEnabled
			? ENGT_CHAT.set('currentScreen', SCREEN_TYPE.LAUNCH)
			: ENGT_CHAT.set('currentScreen', SCREEN_TYPE.CHAT);

		if (popupType === POPUP_OPEN_TYPE.CLOSED && !overridePopup) {
			delay = delay === 0 ? DELAY_CALLOUT_WITH_ANIMATION_TIME : delay;
			setTimeout(onClosedCallout, delay * 1000);
		} else if (popupType === POPUP_OPEN_TYPE.MINIMIZED) {
			if (!delay) {
				delay = 0.5;
			}
			setTimeout(onMinizedCallout, delay * 1000);
		} else if (popupType === POPUP_OPEN_TYPE.NORMAL && !overridePopup) {
			if (delay >= 0) {
				setTimeout(ENGT_CHAT.get('onLauncherClick'), delay * 1000);
			}
		}
	},

	initEventHandlers() {
		this.setupPopup();
	},

	initData() {
		this.data = AppModel;
		this.setter({
			position: ENGT_CHAT.get('config.chat_widget_position'),
		});
	},

	initWrapper() {
		const wrapper = document.createElement('section');

		wrapper.classList.add('engt', `engt-font-${getFontSetting()}`);
		wrapper.innerHTML = AppTemplate(this.data);
		if (isMobileOrTablet()) {
			wrapper.classList.add('engt-mobile-tab');
		}

		this.html = wrapper;
	},

	initComponents() {
		const popupWindow = new Popup().render();
		const launcherIconNodes = new LauncherIcon().render();

		setCustomTagHTML(this.html.querySelector('pop-up'), popupWindow);
		setCustomTagHTML(this.html.querySelector('launcher-icon'), launcherIconNodes);
	},

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	},

	render() {
		this.appElement.appendChild(this.html);
	},
};
